import { Component, Input, OnInit, ViewChild,ChangeDetectionStrategy } from '@angular/core';
import { GlobalService } from '../../services/global.service';

@Component({
    selector: 'app-speed-graph',
    templateUrl: './speed-graph.component.html',
    styleUrls: ['./speed-graph.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SpeedGraphComponent implements OnInit {
	@Input() percentage;
	@Input() total;
	@Input() type = 'number';
	@Input() value;
	@Input() max;
	@Input() item: any;
	@Input() label: any;
	@Input() isBackTranslate: boolean = false;
	@Input() ranges: Array<any> = [-15, -10, -5, 0, 5, 10, 15];
	@Input() maxValuesColors: Array<number> = [3.5, 8.5, 12.5]; // Only allows 3 values: [0] green, [1] yellow, [2] orange...  >[2] is equal to red

	calculatePositionDot(path) {
		let totalLength = path.getTotalLength();
		let start = 0.5;
		let perc = this.max < Math.abs(this.percentage) ? this.max : Math.abs(this.percentage);

		if (this.percentage >= 0) {
			start -= (perc * 0.5) / this.max;
		} else {
			start += (perc * 0.5) / this.max;
		}

		let p = path.getPointAtLength(start * totalLength);
		return `translate(${p.x}, ${p.y})`;
	}

	labelPosition(value, path, type, isText = false, index?) {
		let totalLength = path.getTotalLength();
		let start = 0.5;
		let perc = this.max < Math.abs(value) ? this.max : Math.abs(value);

		if (value >= 0) {
			start -= (perc * 0.5) / this.max;
		} else {
			start += (perc * 0.5) / this.max;
		}

		let p = path.getPointAtLength(start * totalLength);

		if (isText) {
			let extra: any = this.adjustTextPosition(index);
			return type == 'x' ? p.x + extra.x : p.y + extra.y;
		} else {
			return type == 'x' ? p.x : p.y;
		}
	}

	labelRotation(index) {
		let division = Math.floor(this.ranges.length / 2);
		let sumBy = 90 / division;
		return -90 + (sumBy * index)
	}

	lineRotation(index) {
		let division = Math.floor(this.ranges.length / 2);
		let sumBy = 90 / division;
		return sumBy * index;
	}

	needleRotation(path) {
		let angle = 90;
		let perc = this.max < Math.abs(this.percentage) ? this.max : Math.abs(this.percentage);

		if (this.percentage >= 0) {
			angle += (perc * 90) / 15;
		} else {
			angle -= (perc * 90) / 15;
		}

		return angle;
	}

	getCircleClass() {
		let classes = [];
		if (Math.abs(this.percentage) <= this.maxValuesColors[0]) {
			classes.push('is-green');
		} else if (Math.abs(this.percentage) <= this.maxValuesColors[1]) {
			classes.push('is-yellow');
		} else if (Math.abs(this.percentage) <= this.maxValuesColors[2]) {
			classes.push('is-orange');
		} else if (Math.abs(this.percentage) > this.maxValuesColors[2]) {
			classes.push('is-red');
		}
		return classes;
	}

	getValueClass(){
		let classes = [];
		if (Math.abs(this.percentage) <= this.maxValuesColors[1]) {
			classes = [];
		} else if (Math.abs(this.percentage) <= this.maxValuesColors[2]) {
			classes.push('is-orange');
		} else if (Math.abs(this.percentage) > this.maxValuesColors[2]) {
			classes.push('is-red');
		}
		return classes;
	}

	adjustTextPosition(index) {
		let extra = {
			'y': 0,
			'x': 0
		}
		switch (index) {
			case 0: {
				extra.x = -23;
				break;
			}
			case 1: {
				extra.x = -23;
				extra.y = -5;
				break;
			}
			case 2: {
				extra.x = -16;
				extra.y = -11;
				break;
			}
			case 3: {
				extra.x = -5;
				extra.y = -13;
				break;
			}
			case 4: {
				extra.y = -10;
				break;
			}
			case 5: {
				extra.y = -4;
				break;
			}
		}

		return extra;
	}

	getLabel() {
		if (this.label) {
			return this.isBackTranslate ? this._gS.backTranslate(this.item, this.label) : this.item[this.label]
		} else {
			return "--"
		}
	}

	constructor(public _gS: GlobalService) { }

	ngOnInit() {
		
	}

	ngAfterViewInit(){
		// setInterval(() => {
		// 	if(this.percentage < 15){
		// 		this.percentage += 1;
		// 	} else{
		// 		this.percentage = -16;
		// 	}
		// }, 800)
	}

}
